__webpack_require__.S = {};
const initPromises = {};
const initTokens = {};
__webpack_require__.I = (name, initScope) => {
	if(!initScope) initScope = [];
	// handling circular init calls
	let initToken = initTokens[name];
	if(!initToken) initToken = initTokens[name] = {};
	if(initScope.indexOf(initToken) >= 0) return;
	initScope.push(initToken);
	// only runs once
	if(initPromises[name]) return initPromises[name];
	// creates a new share scope if needed
	if(!__webpack_require__.o(__webpack_require__.S, name)) __webpack_require__.S[name] = {};
	// runs all init snippets from all modules reachable
	const scope = __webpack_require__.S[name];
	const warn = (msg) => {
		if (typeof console !== "undefined" && console.warn) console.warn(msg);
	};
	const uniqueName = "coconut-self-assessment-portal";
	const register = (name, version, factory, eager) => {
		const versions = scope[name] ||= {};
		const activeVersion = versions[version];
		if(!activeVersion || (!activeVersion.loaded && (!eager != !activeVersion.eager ? eager : uniqueName > activeVersion.from))) versions[version] = { get: factory, from: uniqueName, eager: !!eager };
	};
	const initExternal = (id) => {
		const handleError = (err) => (warn("Initialization of sharing external failed: " + err));
		try {
			const module = __webpack_require__(id);
			if(!module) return;
			const initFn = (module) => (module && module.init && module.init(__webpack_require__.S[name], initScope))
			if(module.then) return promises.push(module.then(initFn, handleError));
			const initResult = initFn(module);
			if(initResult?.then) return promises.push(initResult['catch'](handleError));
		} catch(err) { handleError(err); }
	}
	const promises = [];
	switch(name) {
		case "default": {
			register("coconut-shared-libraries", "1.0.0", () => (Promise.all([__webpack_require__.e(364), __webpack_require__.e(129), __webpack_require__.e(884), __webpack_require__.e(486), __webpack_require__.e(658), __webpack_require__.e(796)]).then(() => (() => (__webpack_require__(98129))))));
			register("react-dom", "17.0.2", () => (Promise.all([__webpack_require__.e(998), __webpack_require__.e(884)]).then(() => (() => (__webpack_require__(99998))))));
			register("react-hot-toast", "2.6.0", () => (Promise.all([__webpack_require__.e(884), __webpack_require__.e(196)]).then(() => (() => (__webpack_require__(69196))))));
			register("react-query", "3.39.3", () => (Promise.all([__webpack_require__.e(315), __webpack_require__.e(884), __webpack_require__.e(486), __webpack_require__.e(145)]).then(() => (() => (__webpack_require__(4315))))));
			register("react-router-dom", "5.3.4", () => (Promise.all([__webpack_require__.e(982), __webpack_require__.e(884), __webpack_require__.e(427)]).then(() => (() => (__webpack_require__(20982))))));
			register("react", "17.0.2", () => (__webpack_require__.e(483).then(() => (() => (__webpack_require__(82483))))));
			register("styled-components", "5.3.11", () => (Promise.all([__webpack_require__.e(99), __webpack_require__.e(884), __webpack_require__.e(779)]).then(() => (() => (__webpack_require__(68099))))));
		}
		break;
	}
	if(!promises.length) return initPromises[name] = 1;
	return initPromises[name] = Promise.all(promises).then(() => (initPromises[name] = 1));
};